/* eslint-disable */
import React from 'react';
import styled from 'styled-components';
import Wrapper from './Wrapper';

const Button = styled.button`
    border: 0px;
    padding: 5px;
    text-align: left;
    &:focus{
        outline: none;
    }
    &:hover{
        background: #d5d5d5;
    }
    ${props => props.disabled && "pointer-events: none;"}
    background: ${props => props.disabled ? "#d5d5d5" : "transparent"};
`
const Dropdown = (props) => {
    const { data, handleClick } = props;
    return (
        <Wrapper className="w-100">
            {data?.map((val,i) => {
                return (
                    <Button key={i} disabled={val.disabled}>
                        <div onClick={() => handleClick(val)}>
                        {val?.name || val?.application_name || ""}
                        </div>
                    </Button>
                )
            })}
        </Wrapper>
    )
}

export default Dropdown;